import { registroFornecedor } from '@core/util/mockTourUtils';
import { cancelarAlert, excluirAlert } from 'app/services/alerts';
import FornecedorApi from 'app/services/api/fornecedorApi';
import { generateActionTypes, generateDefaultActions } from 'app/store/defaultReducer';
import { eventReactGA } from 'app/utils/analyticsUtil';

const ENTIDADE_FORNECEDOR = 'Fornecedor';
const FORNECEDOR = '[FORNECEDOR]';
const FORNECEDOR_CLOSE_DIALOG = `${FORNECEDOR}_FORNECEDOR_CLOSE_DIALOG`;
const SET_FILTRO_AVANCADO = `${FORNECEDOR}_SET_FILTRO_AVANCADO`;
const FECHAR_MODAL = `${FORNECEDOR}_FECHAR_MODAL`;
const ABRIR_IMPORT_MODAL = `${FORNECEDOR}_ABRIR_IMPORT_MODAL`;
const FECHAR_IMPORT_MODAL = `${FORNECEDOR}_FECHAR_IMPORT_MODAL`;
const SET_FILE_IMPORT = `${FORNECEDOR}_SET_FILE_IMPORT`;
const SHOW_MESSAGE = '[MESSAGE] SHOW';

const initRegistro = {
  pessoa: {
    nome: undefined,
    tipoPessoa: 'JURIDICA',
  },
};

const types = generateActionTypes(FORNECEDOR);

export const FornecedorTypes = {
  ...types,
  SET_FILTRO_AVANCADO,
  FECHAR_MODAL,
  FORNECEDOR_CLOSE_DIALOG,
  ABRIR_IMPORT_MODAL,
  FECHAR_IMPORT_MODAL,
  SET_FILE_IMPORT,
  SHOW_MESSAGE,
};

export const INIT = {
  pessoa: {
    nome: undefined,
    tipoPessoa: 'JURIDICA',
  },
};

const setFileImport = (dispatch, file) => {
  dispatch({
    type: FornecedorTypes.SET_FILE_IMPORT,
    payload: file,
  });
};

const setFiltroAvancado = (dispatch, filtroAvancado) => {
  dispatch({ type: SET_FILTRO_AVANCADO, payload: filtroAvancado });
};

function abrirImportModal(dispatch) {
  const action = {
    type: FornecedorTypes.ABRIR_IMPORT_MODAL,
  };
  dispatch(action);
}

function fecharImportModal(dispatch) {
  const action = {
    type: FornecedorTypes.FECHAR_IMPORT_MODAL,
  };
  dispatch(action);
}

function fecharModal(dispatch, dirty) {
  const action = {
    type: FornecedorTypes.FECHAR_MODAL,
  };

  if (dirty) {
    cancelarAlert({
      confirmar: async () => {
        dispatch(action);
      },
    });
  } else {
    dispatch(action);
  }
}

function excluirFornecedores(dispatch, fornecedores, todosDoFiltro, params) {
  excluirAlert({
    opcoes: {
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
    },
    confirmar: async () => {
      dispatch(FornecedorActions.setCarregandoRegistros(true));
      try {
        eventReactGA(ENTIDADE_FORNECEDOR, 'Excluir fornecedor');
        if (todosDoFiltro) {
          await FornecedorApi.removerFornecedoresTodosFiltro({ ids: fornecedores, q: params.q });
        } else {
          await FornecedorApi.removerFornecedores(fornecedores);
        }
        dispatch(FornecedorActions.sucesso('Fornecedor excluído com sucesso'));
        carregarRegistros(dispatch, params);
      } catch (error) {
        dispatch(FornecedorActions.erro(error?.response?.data?.message));
      } finally {
        dispatch(FornecedorActions.setCarregandoRegistros(false));
      }
    },
  });
}

const filterEmailAdicional = (emailAdicional) => {
  return !!emailAdicional?.email;
};

const filterTelefoneAdicional = (telefoneAdicional) => {
  return !!telefoneAdicional?.numero;
};

async function onSubmit(dispatch, fornecedor, requestParams, filtroAvancado) {
  try {
    dispatch(FornecedorActions.setCarregarRegistro(true));
    if (fornecedor.pessoa.contatos?.length > 0) {
      for (let i = 0; i < fornecedor.pessoa.contatos.length; i++) {
        const contato = fornecedor.pessoa.contatos[i];

        if (contato?.emailsAdicionais?.length > 0) {
          contato.emailsAdicionais = contato.emailsAdicionais.filter(filterEmailAdicional);
        }

        if (contato?.telefonesAdicionais?.length > 0) {
          contato.telefonesAdicionais = contato.telefonesAdicionais.filter(filterTelefoneAdicional);
        }
      }
    }

    if (fornecedor.id) {
      eventReactGA(ENTIDADE_FORNECEDOR, 'Atualizar fornecedor');
      await FornecedorApi.atualizar(fornecedor.id, fornecedor);
      dispatch(FornecedorActions.sucesso('Fornecedor editado com sucesso', fornecedor));
    } else {
      eventReactGA(ENTIDADE_FORNECEDOR, 'Cadastrar fornecedor');
      await FornecedorApi.cadastrar(fornecedor);
      dispatch(FornecedorActions.sucesso('Fornecedor salvo com sucesso', fornecedor));
    }

    dispatch(FornecedorActions.limparSelecao());
    carregarRegistros(dispatch, requestParams, filtroAvancado);
  } catch (error) {
    dispatch(FornecedorActions.erro(error?.response?.data?.message));
  } finally {
    dispatch(FornecedorActions.setCarregarRegistro(false));
  }
}

async function carregarRegistros(dispatch, queryParams = {}, filtroAvancado = {}) {
  try {
    dispatch(FornecedorActions.setCarregandoRegistros(true));
    if (filtroAvancado?.pessoa?.endereco?.uf?.nome) {
      filtroAvancado.uf = queryParams?.pessoa?.endereco?.uf?.nome;
      delete filtroAvancado.uf;
    }

    const filtro = {
      ...queryParams,
      ...filtroAvancado,
      uf: filtroAvancado?.pessoa?.endereco?.uf?.nome,
    };

    const resp = await FornecedorApi.buscar(filtro);
    dispatch(FornecedorActions.setCurrentPage(resp.data.number));
    dispatch(FornecedorActions.setPageSize(resp.data.size));
    dispatch(FornecedorActions.buscar(resp.data));
  } catch (error) {
    dispatch(FornecedorActions.erro(error?.response?.data?.message));
  } finally {
    dispatch(FornecedorActions.setCarregandoRegistros(false));
  }
}

async function buscarTour(dispatch) {
  dispatch(FornecedorActions.setCurrentPage(registroFornecedor.number));
  dispatch(FornecedorActions.setPageSize(registroFornecedor.size));
  dispatch(FornecedorActions.buscar(registroFornecedor));
}

const requestEditar = async (dispatch, id) => {
  try {
    dispatch(FornecedorActions.carregandoRegistro(true));
    const response = await FornecedorApi.buscarPorId(id);
    dispatch(FornecedorActions.editar(response.data));
  } finally {
    dispatch(FornecedorActions.carregandoRegistro(false));
  }
};

const requestVisualizar = async (dispatch, id) => {
  try {
    dispatch(FornecedorActions.carregandoRegistro(true));
    const response = await FornecedorApi.buscarPorId(id);
    dispatch(FornecedorActions.visualizar(response.data));
  } finally {
    dispatch(FornecedorActions.carregandoRegistro(false));
  }
};

function fecharModalCadastro(dispatch, dirty, clearFormFornecedor) {
  const action = {
    type: FORNECEDOR_CLOSE_DIALOG,
  };

  if (dirty) {
    cancelarAlert({
      confirmar: async () => {
        if (clearFormFornecedor) {
          clearFormFornecedor(initRegistro);
        }
        dispatch(action);
      },
    });
  } else {
    dispatch(action);
  }
}

const defaultActions = generateDefaultActions(FornecedorTypes);

export const FornecedorActions = {
  ...defaultActions,
  cadastrar: () => defaultActions.cadastrar(initRegistro),
  onSubmit,
  abrirImportModal,
  fecharImportModal,
  carregarRegistros,
  excluirFornecedores,
  fecharModalCadastro,
  requestEditar,
  requestVisualizar,
  setFiltroAvancado,
  fecharModal,
  buscarTour,
  setFileImport,
};
